import {
    VenueAnalysisConfigurationState,
    initialVenueAnalysisConfigurationState,
} from './configuration/VenueAnalysisConfigurationState';
import {
    VenueAnalysisComponentState,
    initialVenueAnalysisComponentState,
} from './component/VenueAnalysisComponentState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';

export type VenueAnalysisWidgetState =
    WidgetWithConfigState<VenueAnalysisConfigurationState> &
        WidgetWithComponentState<VenueAnalysisComponentState>;

export interface VenueAnalysisWidgetsState {
    [widgetId: string]: VenueAnalysisWidgetState;
}

export const initialVenueAnalysisWidgetState: VenueAnalysisWidgetState = {
    component: initialVenueAnalysisComponentState,
    config: initialVenueAnalysisConfigurationState,
};

export const initialVenueAnalysisWidgetsState: VenueAnalysisWidgetsState = {};
